import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LetDirective } from '@ngrx/component';
import { has } from 'lodash';

import { Policy, Quote } from '@lockton-apps/shared/interfaces';
import { AvatarModule } from '@lockton-apps/shared/ui/lui';
import {
  InfoLevelColorPipe,
  PolicyStatusMetaPipe,
  WorkflowMetaPipe,
} from '@lockton-apps/shared/ui/pipes';
import {
  QuoteStatusColorPipe,
  QuoteStatusDescriptionPipe,
  QuoteStatusIconPipe,
} from '@lockton-apps/shared/ui/quote-status-indicator';

import { DynamicTableColumnTemplate } from '../column-template.directive';

interface StatusProps {
  path: string;
  entityType: string;
  size: number;
}

@Component({
    selector: 'la-status',
    templateUrl: './status.component.html',
    imports: [
        CommonModule,
        AvatarModule,
        QuoteStatusIconPipe,
        QuoteStatusDescriptionPipe,
        QuoteStatusColorPipe,
        PolicyStatusMetaPipe,
        WorkflowMetaPipe,
        LetDirective,
        MatTooltipModule,
        MatIconModule,
        InfoLevelColorPipe,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StatusComponent extends DynamicTableColumnTemplate<StatusProps> {
  isQuote(entity: unknown): entity is Quote {
    return has(entity, 'status') && has(entity, 'type');
  }

  isPolicy(entity: unknown): entity is Policy {
    return has(entity, 'status') && has(entity, 'inceptionDate');
  }
}
